import React from 'react';
import { InlineAlertSelected } from '../inlineAlertSelected/InlineAlertSelected';

export type SelectModeCountMenuProps = {
    count: number,
    isSelected: boolean,
    iconControls: JSX.Element
}

export const SelectModeCountMenu = (props: SelectModeCountMenuProps) => {

    return (
        <div className='select-mode-count-menu'>
            <InlineAlertSelected message="Selected"
                count={props.count}
                isSelected={props.isSelected}
            />
            <div className='seperator'></div>
            <div className='controls'>
                {props.iconControls}
            </div>
        </div>)
};